import { render, staticRenderFns } from "./FavouriteLenders.vue?vue&type=template&id=bc9663fe&"
import script from "./FavouriteLenders.vue?vue&type=script&lang=js&"
export * from "./FavouriteLenders.vue?vue&type=script&lang=js&"
import style0 from "./FavouriteLenders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports